import { useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { createAuthGuard } from "@ticketon/authentication-session";
import { useAuth, AUTH_ROUTES } from "@ticketon/authentication-core";
import { sessionManager } from "./sessionBridge";
import { DashboardRoutes } from "@/modules/dashboard";

const authGuard = createAuthGuard(
  {
    loginPath: AUTH_ROUTES.LOGIN,
    homePath: DashboardRoutes.INDEX,
    authPaths: [AUTH_ROUTES.LOGIN, AUTH_ROUTES.FORGOT_PASSWORD, AUTH_ROUTES.RESET_PASSWORD],
    protectedPaths: ["/*"],
    callbackParam: "callbackUrl",
  },
  sessionManager
);

export function AuthGuard() {
  const { isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoading) return;

    const decision = authGuard.decide(location.pathname);
    if (decision.action === "redirect") {
      navigate(decision.to, { replace: true });
    }
  }, [isLoading, isAuthenticated, location.pathname, navigate]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return <Outlet />;
}
